var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTajikistan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 7h30v10H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#bc271a",
    d: "M30 7H0V0h30z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2b6519",
    d: "M30 24H0v-7h30z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#efc443",
    d: "M16.76 13.31a1.17 1.17 0 0 1-1.97-.75v-.92a.39.39 0 0 1 .72-.18.9.9 0 1 0-1.73 0 .38.38 0 0 1 .72.18v.92a1.17 1.17 0 0 1-1.97.75 1.22 1.22 0 0 1-1.84.54c.12 1.12 1.8.9 1.92-.2.53.93 1.7.66 2.04-.47.34 1.13 1.5 1.4 2.03.47.12 1.1 1.8 1.32 1.92.2a1.2 1.2 0 0 1-1.19.13q-.46-.2-.65-.67"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#efc443",
    d: "M13.38 14.56s-.12-.08-.37-.04a.7.7 0 0 0-.27-.37c-.1.1-.17.3-.13.44-.18.03-.35.15-.35.15.41.41.88.32 1.12-.18m1.83-.06s-.1-.1-.35-.1a.7.7 0 0 0-.21-.4.6.6 0 0 0-.2.4c-.18.01-.36.1-.36.1.33.47.81.46 1.13 0m1.35-.35a.6.6 0 0 0-.27.38c-.18-.03-.37.03-.37.03.26.52.73.58 1.12.18 0 0-.1-.1-.34-.15a.7.7 0 0 0-.14-.44"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#efc443",
    d: "m11.59 15.45.14.47a10 10 0 0 1 5.84 0l.14-.47c-2-.6-4.13-.6-6.12 0m2.78-7-.18.53.46-.33.45.33-.17-.54.45-.33h-.56l-.17-.53-.18.53h-.56zm-2.16.57-.17.53.45-.33.45.33-.17-.53.45-.33h-.56l-.17-.53-.17.53h-.56zm-1.58 1.58-.17.53.45-.33.45.33-.17-.53.45-.33h-.56l-.17-.53-.17.53h-.56zm-.3 2.36.46.33-.18-.53.46-.33h-.56l-.18-.53-.17.53H9.6l.45.33-.17.53zm6.2-3.94-.18.53.45-.33.46.33-.18-.53.46-.33h-.56l-.18-.53-.17.53h-.56zm1.57 1.58-.17.53.45-.33.46.33-.18-.53.46-.33h-.56l-.18-.53-.17.53h-.56zm1.14 2.16.45-.33h-.56l-.17-.53-.17.53h-.56l.45.33-.17.53.45-.33.45.33z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTajikistan);
export default __webpack_public_path__ + "static/media/tajikistan.629a7d793492b4fce51cde7ffde1423d.svg";
export { ForwardRef as ReactComponent };